import { render, staticRenderFns } from "./navMenu.vue?vue&type=template&id=620bbe6e&scoped=true&"
import script from "./navMenu.vue?vue&type=script&lang=js&"
export * from "./navMenu.vue?vue&type=script&lang=js&"
import style0 from "./navMenu.vue?vue&type=style&index=0&id=620bbe6e&lang=scss&scoped=true&"
import style1 from "./navMenu.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620bbe6e",
  null
  
)

export default component.exports